



















































































































import { Component, Mixins } from 'vue-property-decorator';
import { appName, appEnv, gitCommitShortSHA, versionTag } from '@/env';
import { readUserProfile, readIsEditMode } from '@/store/main/getters';
import { dispatchUserLogOut } from '@/store/main/actions';
import NavBarMixin from '../mixins/NavBarMixin';

@Component
export default class NavBar extends Mixins(NavBarMixin) {
  public appName = appName;
  public appEnv = appEnv;
  public toggle = false;
  public gitCommitShortSHA = gitCommitShortSHA;
  public versionTag = versionTag;

  public toggleMenu() {
    this.toggle = !this.toggle;
  }
  public goToHome() {
    const route = { name: 'home' };
    this.$router.push(route);
  }

  public get isEditMode() {
    if (this.$route.query.mode === 'edit' || this.$route.params.id === 'new') {
      return true;
    }
    return readIsEditMode(this.$store);
  }
  public get appTitle() {
    if (appEnv === 'staging') {
      return appName + ' - STAGING';
    } else if (appEnv === 'stagingV2') {
      return appName + ' - STAGINGV2';
    } else {
      return appName;
    }
  }

  public get nestedNavItems() {
    console.log('nestedNavItems', this.navItems.filter(n => n.menuItems));
    return this.navItems.filter(n => n.menuItems);
  }

  public get userDisplayName() {
    const profile = readUserProfile(this.$store);
    return profile ? profile.full_name : '?';
  }

  public async logout() {
    await dispatchUserLogOut(this.$store);
  }

  // public toggleDarkMode() {
  //   this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
  //   localStorage.setItem('dark_theme', this.$vuetify.theme.dark.toString());
  // }
}
